// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"324":"fc56bb52","404":"66b9cf7b","498":"c0f435c9","513":"d7154604"}[chunkId] + ".chunk.js";
};